import { type ReactElement } from 'react'
import * as S from './link-button.styled'
import { type LinkProps } from 'react-router-dom'

export function LinkButton (props: LinkProps): ReactElement {
  return <S.LinkButton {...props} />
}
